<template>
  <v-card flat class="pa-4 mb-4">
    <div class="d-flex align-center justify-center">
      <v-btn icon :disabled="disablePrevious" @click="$emit('previous')">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <div class="mx-6 text-center">
        <div class="text-h4 font-weight-bold">
          {{ year }}
        </div>

        <!----<div class="grey--text">Année 1/6</div>-->
      </div>

      <v-btn icon :disabled="disableNext" @click="$emit('next')">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    year: { type: Number, required: true },
    disablePrevious: { type: Boolean, default: false },
    disableNext: { type: Boolean, default: false },
  },
};
</script>
